import React, { useState } from "react";
import PdfDownload from "./PDFDownload";
import { emails } from "../constants";
import AccordionCard from "./AccordionCard";
import { BsTelephone } from "react-icons/bs";
import { VideoTile } from "./Utility/VideoTile";
import ReturnsCustomer from "../assets/videos/Customer Tutorials/Returns - Customers.mp4";
import { BackButton } from "./Utility/BackButton";
import { DiliTextCP } from "./Utility/DiliTextCP";
import { HighlightText } from "./Utility/HighlightText";
import { HelmetUtil } from "./Utility/HelmetUtil";
import { VideoModal } from "./Utility/VideoModal";

const videoGuides = [
  {
    video: ReturnsCustomer,
    title: "Order Tracking and Returns",
  },
];

const HelpPageCustomer = () => {
  //searching logic is already in place if we ever add more videos to the customer help page.
  //just need to uncomment the search input field
  const [guidesSearchFilter, setGuidesSearchFilter] = useState("");
  const handleChangeGuidesSearchFilter = (event) => {
    setGuidesSearchFilter(event.target.value);
  };

  const [showVideoModal, setShowVideoModal] = useState();
  const [selectedVideoIndex, setSelectedVideoIndex] = useState();
  const handleSelectVideo = (videoThatWasClicked) => {
    setSelectedVideoIndex(videoThatWasClicked);
    setShowVideoModal(true);
  };
  const handleCloseVideo = () => {
    setShowVideoModal(false);
    setSelectedVideoIndex();
  };

  const filteredVideoGuides = videoGuides.filter(
    (guide) =>
      guidesSearchFilter === "" ||
      guide?.title.toLowerCase().includes(guidesSearchFilter.toLowerCase())
  );
  return (
    <>
      <VideoModal
        show={showVideoModal}
        onHide={handleCloseVideo}
        videoSrc={videoGuides[selectedVideoIndex]?.video}
        videoTitle={videoGuides[selectedVideoIndex]?.title}
      />
      <HelmetUtil title="Help" />
      <div className="help-page">
        <h1 className="help-page-heading">Help</h1>

        <div className="help-page-container container form-container px-0 py-0">
          <div className="help-page-video-container container form-container">
            <div className="d-flex justify-content-between">
              <h3>Video Guides</h3>
              {/* <DiliTextCP
                  inputStyle={{ boxShadow: "0px 0px 5px rgba(0,0,5,.2)" }}
                  value={guidesSearchFilter}
                  onChange={handleChangeGuidesSearchFilter}
                  placeholder="Type to filter"
                ></DiliTextCP> */}
            </div>

            <div className="pt-4 pb-2">
              <div
                className="panel-flat"
                style={{ boxShadow: "0px 0px 5px rgba(0,0,0,.1)" }}
              >
                {filteredVideoGuides.length > 0 ? (
                  filteredVideoGuides.map((guide, index) => {
                    return (
                      <a
                        role="button"
                        style={{ display: "block" }}
                        className="px-2 py-2 remove-last-item-border help-guide-video-list-item clickable"
                        onClick={() => {
                          handleSelectVideo(index);
                        }}
                      >
                        <HighlightText
                          fullText={guide.title}
                          textToHighlight={guidesSearchFilter}
                        />
                        {/* {guide.title} */}
                      </a>
                    );
                  })
                ) : (
                  <div className="text-center p-2">No Results Found</div>
                )}
              </div>
            </div>

            {/* <h3 className="help-page-video-heading mb-2">Demo</h3>

          <video className="diligent-client-portal-demo-video" controls>
            <source src={DiligentClientPortalDemoVideo} type="video/mp4" />
          </video> */}
          </div>

          {/* <div className="container px-0 py-0 form-container">
            <PdfDownload
              title="Help Documents"
              subtitle="PDF Guides"
              eventKey="helpDocuments"
            >
              <option value={PDFS.userGuidePdf}>User Guide.pdf</option>
            </PdfDownload>
          </div>
          <AccordionCard
            eventKey="helpContact"
            title="Support Contact Information"
            icon={BsTelephone}
          >
            <div>{emails.supportEmail}</div>
          </AccordionCard> */}
        </div>
      </div>
    </>
  );
};

export default HelpPageCustomer;
